// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as MutationHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/MutationHook2.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["mutation requestTrophyData($userId: String!)  {\nrequestTrophyData(userId: $userId)  {\n__typename  \nsource  \ngold  \n}\n\n}\n"]);

function parse(value) {
  var value$1 = value.requestTrophyData;
  return {
          requestTrophyData: value$1.map(function (value) {
                return {
                        __typename: value.__typename,
                        source: value.source,
                        gold: value.gold
                      };
              })
        };
}

function serialize(value) {
  var value$1 = value.requestTrophyData;
  var requestTrophyData = value$1.map(function (value) {
        var value$1 = value.gold;
        var value$2 = value.source;
        var value$3 = value.__typename;
        return {
                __typename: value$3,
                source: value$2,
                gold: value$1
              };
      });
  return {
          requestTrophyData: requestTrophyData
        };
}

function serializeVariables(inp) {
  return {
          userId: inp.userId
        };
}

function makeVariables(userId, param) {
  return {
          userId: userId
        };
}

var Mutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Mutation.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useWithState = include.useWithState;

var Mutation = {
  Mutation_inner: Mutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useWithState: useWithState
};

var M = MutationHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useWithState: useWithState
    });

function use$1(param) {
  var request = Curry._1(M.useAsync, "RequestTrophyDataMutation");
  return async function (userId) {
    var match = await Curry._1(request, {
          userId: userId
        });
    var match$1 = match.data;
    if (match$1 !== undefined) {
      return match$1.requestTrophyData;
    } else {
      return [];
    }
  };
}

export {
  Mutation ,
  M ,
  use$1 as use,
}
/* query Not a pure module */
